import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'splitMapJoin'
})
export class SplitMapJoinPipe implements PipeTransform {

  transform(value: unknown, key: string, separator: string = ', '): string {
    if (!Array.isArray(value)) return '';
    return value.map(item => item?.[key]).filter(Boolean).join(separator);
  }

}
